import "./index.css"

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {Provider} from "react-redux";
import {persistor, store} from "./store/store";
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from '@mui/material';
import theme from './lib/Theme';
import {Toaster} from "react-hot-toast";
import ErrorBoundary from "./routes/error/error.route";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
          <ThemeProvider theme={theme}>
              <ErrorBoundary>
                  <App/>
                  <Toaster />
              </ErrorBoundary>
          </ThemeProvider>
        </PersistGate>
    </Provider>
);
